import { Alert, Snackbar } from "@mui/material";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { clearalertSnackbar } from "../store/Slice/alertStatusSlice";

export default function AlertSnackbar() {
  const dispatch = useDispatch();
  const alert = useSelector(({ alert }) => alert);
  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    dispatch(clearalertSnackbar());
  };
  return (
    <Snackbar
      open={alert.openSnackbar}
      autoHideDuration={5000}
      onClose={handleClose}
      anchorOrigin={{ vertical: "top", horizontal: "right" }}
    >
      <Alert
        onClose={handleClose}
        severity={alert.statusSnackbar}
        sx={{ width: "100%" }}
      >
        {alert.msgSnackbar}
      </Alert>
    </Snackbar>
  );
}
